import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import {DashboardModel} from "../../models/dashboard.model";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import * as _ from "lodash";
import {DashboardsServiceService} from "../../services/dashboards-service.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../../commons/models/view-settings.model";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {WidgetModel} from "../../models/widget.model";
import {DataSourceConfigurationModel} from "../../models/data-source-configuration.model";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {DashboardWidgetConfigurationEnum} from "../../enums/dashboard-widget-configuration.enum";

export class DashboardsViewComponents implements IController {

  from: number;
  to: number;
  favoriteDashboardSettings: ViewSettingsModel;
  favoriteDashboard: DashboardModel;
  datasourceConfigurations: DataSourceConfigurationModel[];
  userOperationalData: any;

  public isDashboardsListOpen: boolean = false;
  public dashboardForm: DashboardModel;
  public widgetForm: WidgetModel;
  public selectedDashboard: DashboardModel;
  public dateCustomTemplates: any;
  public dateRange: any;
  public currentUser: any;
  public maximumWidgetsPerDashboard: number;
  public reOrderWidgetMode: boolean = false;
  public isCopyDashboardAction: boolean = false;
  public dashboardWidgetConfiguration: typeof DashboardWidgetConfigurationEnum = DashboardWidgetConfigurationEnum;
  public datasourceConfigurationsMap: any;
  public hasPermissionToCreatePublicDashboard: boolean;
  public userBranchesIntersectionTeamMap: any;
  public isBigScreen: boolean;

  constructor(private confirmDialogService: ConfirmDialogService, private dashboardsServiceService: DashboardsServiceService,
              private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private viewSettingsService: ViewSettingsService,
              private UUIDService, private UserService, private siteContextService: SiteContextService, private $timeout: ITimeoutService,
              private IAMPermissions, private $mdMedia) {
  }

  $onInit() {

    this.setBranchesIntersectionTeamsMap(this.userOperationalData.branches, this.userOperationalData.teams);

    this.datasourceConfigurationsMap = {};
    this.datasourceConfigurations.forEach(item => {
      this.datasourceConfigurationsMap[item.widgetDatasource] = item;
    })

    this.hasPermissionToCreatePublicDashboard = this.IAMPermissions.hasPermission('dashboard.publish');
    this.maximumWidgetsPerDashboard = this.siteContextService.getSiteInfo().dashboardAllowedNumberOfWidgets;
    this.currentUser = this.UserService.getCurrentUser();
    this.dateRange = this.from && this.to ? {
      dateStart: this.from,
      dateEnd: this.to
    } : this.dateRangeTimeFiltersService.today();

    this.dateCustomTemplates = this.dateRangeTimeFiltersService.getDefaultCustomTemplates();
    if (!this.favoriteDashboard) {
      this.isDashboardsListOpen = true;
    } else {
      this.selectedDashboard = this.favoriteDashboard;
    }
  }

  $doCheck() {
    this.isBigScreen = this.$mdMedia('gt-sm');
  };

  onToggleDashboardsListSideNav(value) {
    if (value && (this.dashboardForm)) {
      this.onCloseForm().then(() => {
        this.dashboardForm = undefined;
        this.widgetForm = undefined;
        this.isDashboardsListOpen = value;
      })

    } else {
      this.isDashboardsListOpen = value;
    }
  }

  onToggleCreateDashboard() {
    this.isDashboardsListOpen = false;

    if (this.dashboardForm) {
      return;
    }
    this.dashboardForm = {name: undefined, isPublic: false, widgetViewConfigurations: [], dashboardDesign: {}};
  }

  closeForm() {
    this.onCloseForm().then(() => {
      this.dashboardForm = undefined;
      this.widgetForm = undefined;
    })
  }

  onCloseForm() {
    return this.confirmDialogService.confirm("Abort current activity", "Are you sure you want to stop your current activity? Any unsaved changes may be lost");
  }

  onCreateUpdateDashboard(dashboard: DashboardModel) {
    //call create dashboard api
    if (!!dashboard.id) {
      this.updateDashboard(dashboard)
        .then((dashboard: DashboardModel) => {
          this.selectedDashboard = angular.copy(dashboard);
          this.dashboardForm = undefined;

          this.$timeout(() => {

          }, 0);
        })
    } else {
      this.createDashboard(dashboard)
        .then((dashboard: DashboardModel) => {
          if (!this.favoriteDashboard) {
            this.onSetDashboardAsFavorite(dashboard);
          }
          if (!this.isCopyDashboardAction) {
            this.widgetForm = {metrics: {}, filters: {}, columns: []};
            this.dashboardForm = dashboard;
          } else {
            this.dashboardForm = undefined;
          }
          this.selectedDashboard = angular.copy(dashboard);
          this.isCopyDashboardAction = false;

          this.$timeout(() => {

          }, 0);
        })
    }
  }

  createDashboard(dashboard: DashboardModel) {
    return this.dashboardsServiceService.createDashboard(dashboard);
  }

  updateDashboard(dashboard: DashboardModel) {
    return this.dashboardsServiceService.updateDashboard(dashboard);
  }

  onCreateUpdateWidget(widget: WidgetModel, isCreateAnother: boolean) {
    if (!widget.identification) {
      widget.identification = this.UUIDService.generate();
      if (!this.dashboardForm.dashboardDesign) {
        this.dashboardForm.dashboardDesign = {};
      }
      if (!this.dashboardForm.dashboardDesign.widgetSizeConfiguration) {
        this.dashboardForm.dashboardDesign.widgetSizeConfiguration = {}
      }
      this.dashboardForm.dashboardDesign.widgetSizeConfiguration[widget.identification] = {
        id: widget.identification,
        cols: 4,
        rows: 12,
        y: 0,
        x: 0,
        ...this.dashboardWidgetConfiguration[widget.datasource][widget.widgetType]
      };
    }
    if (!this.dashboardForm.widgetViewConfigurations) {
      this.dashboardForm.widgetViewConfigurations = []
    }

    const widgetIndex = this.selectedDashboard.widgetViewConfigurations.findIndex(w => w.identification === widget.identification);

    if (widgetIndex === -1) {
      this.dashboardForm.widgetViewConfigurations.push(widget);
    } else {
      this.dashboardForm.widgetViewConfigurations[widgetIndex] = widget;
    }

    this.dashboardsServiceService.updateDashboard(this.dashboardForm)
      .then((dashboard: DashboardModel) => {
        this.selectedDashboard = angular.copy(dashboard);
        if (isCreateAnother) {
          this.dashboardForm = dashboard;
          this.widgetForm = {metrics: {}, filters: {}, columns: []};
        } else {
          this.dashboardForm = undefined;
          this.widgetForm = undefined;
        }

        this.$timeout(() => {

        }, 0);
      })
  }

  onEditDashboard() {
    this.isDashboardsListOpen = false;


    if (this.widgetForm || this.dashboardForm) {
      this.onCloseForm().then(() => {
        this.widgetForm = undefined;
        this.dashboardForm = undefined;

        this.dashboardForm = angular.copy(this.selectedDashboard);
      });
    } else {
      this.dashboardForm = angular.copy(this.selectedDashboard);
    }
  }

  onSelectDashboard(dashboard: DashboardModel) {
    this.selectedDashboard = undefined;
    this.$timeout(() => {
      this.selectedDashboard = angular.copy(dashboard);
    }, 0);
  }

  onSetDashboardAsFavorite(dashboard: DashboardModel) {
    if (this.favoriteDashboardSettings) {
      const favoriteDashboardSettingsCopy = {...this.favoriteDashboardSettings, pageName: dashboard.id}
      this.viewSettingsService.updateByUser(favoriteDashboardSettingsCopy.id, favoriteDashboardSettingsCopy)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.favoriteDashboardSettings = viewSettingsTable;
          this.favoriteDashboard = dashboard;
        })
    } else {
      const viewTableSettings = {
        pageName: dashboard.id,
        holderType: ViewSettingsHolderType.User,
        settingsType: ViewSettingsType.Dashboard
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.favoriteDashboardSettings = viewSettingsTable;
          this.favoriteDashboard = dashboard;
        })
    }
  }

  onDateRangeChanged(range) {
    if (!_.isUndefined(range) && (!_.isEqual(range.dateStart, this.dateRange.dateStart) || !_.isEqual(range.dateEnd, this.dateRange.dateEnd))) {
      this.dateRange = range;
    }
  }

  onAddWidget() {
    this.isDashboardsListOpen = false;

    if (this.dashboardForm || this.widgetForm) {
      this.onCloseForm().then(() => {
        this.dashboardForm = angular.copy(this.selectedDashboard);
        this.widgetForm = {metrics: {}, filters: {}, columns: []};
      })
    } else {
      this.dashboardForm = angular.copy(this.selectedDashboard);
      this.widgetForm = {metrics: {}, filters: {}, columns: []};
    }
  }

  deleteDashboard() {
    this.dashboardsServiceService.deleteDashboard(this.selectedDashboard.id).then(() => {
      this.selectedDashboard = undefined;
    })
  }

  onCopyDashboard() {
    this.dashboardForm = {...this.selectedDashboard, id: undefined, ownerId: undefined, ownerName: undefined};
    if (this.dashboardForm.isPublic && !this.hasPermissionToCreatePublicDashboard) {
      this.dashboardForm.isPublic = false;
    }
    this.isDashboardsListOpen = false;
    this.isCopyDashboardAction = true;
  }

  onEditWidget(widget: WidgetModel) {
    this.isDashboardsListOpen = false;

    if (this.dashboardForm || this.widgetForm) {
      this.onCloseForm().then(() => {
        this.widgetForm = angular.copy(widget);
        this.dashboardForm = angular.copy(this.selectedDashboard);
      })
    } else {
      this.widgetForm = angular.copy(widget);
      this.dashboardForm = angular.copy(this.selectedDashboard);
    }
    this.$timeout(0).then(() => {
    });
  }

  onDeleteWidget(data: { index: number, widget: WidgetModel }) {
    let dashboardCopy = angular.copy(this.selectedDashboard);
    dashboardCopy.widgetViewConfigurations.splice(data.index, 1);

    if (!!dashboardCopy.dashboardDesign?.widgetSizeConfiguration && !!dashboardCopy.dashboardDesign?.widgetSizeConfiguration[data.widget.identification]) {
      delete dashboardCopy.dashboardDesign.widgetSizeConfiguration[data.widget.identification]
    }

    this.dashboardsServiceService.updateDashboard(dashboardCopy).then(() => {
      this.selectedDashboard.widgetViewConfigurations.splice(data.index, 1);

      this.$timeout(0).then(() => {
      });
    })
  }

  onChangeDashboardPublicState(isPublic: boolean) {
    this.dashboardsServiceService.changeDashboardPublicState(this.selectedDashboard.id, isPublic).then((updatedDashboard: DashboardModel) => {
      this.selectedDashboard.isPublic = updatedDashboard.isPublic;
    })
  }

  private setBranchesIntersectionTeamsMap(userBranches, userTeams) {
    this.userBranchesIntersectionTeamMap = {
      branchIds: [],
      agentIds: []
    }
    if (!userBranches?.length || !userTeams?.length) {
      return;
    }

    const userTeamAgents = _.uniqBy(_.flatMap(userTeams, 'agents'), 'id');

    userBranches.forEach(branch => {
      userTeamAgents.forEach(agent => {
        if (agent.branchIds?.includes(branch.id)) {
          this.userBranchesIntersectionTeamMap.branchIds.push(branch.id);
          this.userBranchesIntersectionTeamMap.agentIds.push(agent.id);
        }
      })
    })

    this.userBranchesIntersectionTeamMap.branchIds = _.uniq(this.userBranchesIntersectionTeamMap.branchIds);
    this.userBranchesIntersectionTeamMap.agentIds = _.uniq(this.userBranchesIntersectionTeamMap.agentIds);
  }

}

angular
  .module('bringoz.admin.dashboards')
  .component('dashboardsView', {
    bindings: {
      datasourceConfigurations: '<',
      favoriteDashboardSettings: '<?',
      favoriteDashboard: '<?',
      userOperationalData: '<?'
    },
    template: require('./dashboards-view.html').default,
    controller: DashboardsViewComponents
  });
